/**
 * Creates a `NumericRangeRequest`.
 *
 * @param config - The options with which to create a `NumericRangeRequest`.
 * @returns A new `NumericRangeRequest`.
 */
export function buildNumericRange(config) {
    return {
        endInclusive: false,
        state: 'idle',
        ...config,
    };
}
